var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 10.1698C1.66675 8.26234 1.66675 7.309 2.10008 6.519C2.53175 5.72817 3.32258 5.23817 4.90342 4.2565L6.57008 3.22234C8.24092 2.18484 9.07675 1.6665 10.0001 1.6665C10.9234 1.6665 11.7584 2.18484 13.4301 3.22234L15.0967 4.2565C16.6776 5.23817 17.4684 5.72817 17.9009 6.519C18.3334 7.30984 18.3334 8.26234 18.3334 10.169V11.4373C18.3334 14.6873 18.3334 16.3132 17.3568 17.3232C16.3801 18.3332 14.8093 18.3332 11.6667 18.3332H8.33342C5.19092 18.3332 3.61925 18.3332 2.64341 17.3232C1.66758 16.3132 1.66675 14.6882 1.66675 11.4373V10.1698Z",
    stroke: "black",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 10.6665H10.0002M10.0002 10.6665H7.50024M10.0002 10.6665V8.1665M10.0002 10.6665V13.1665",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousePlus);
export default __webpack_public_path__ + "static/media/house_plus.06df4dcf939b2a3a6b71e0735fdc0b75.svg";
export { ForwardRef as ReactComponent };